<ng-template #content let-modal>
  <div class="modal-body">
    <app-image-editor #imageEditor [(imageBase64)]="image" (imageBase64Change)="saveImage($event, modal)"></app-image-editor>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn px-5 btn-danger" (click)="close(modal)">Cancelar</button>
    <button type="button" class="btn px-5 btn-success" (click)="save(imageEditor)">Salvar</button>
  </div>
</ng-template>
